import styled from 'styled-components'

type ToastContainerProps = {
  type: 'error' | 'success' | 'warning' | 'default'
  isCross?: boolean
}

export const ToastsContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 10px;

  position: fixed;
  bottom: 20px;
  right: 32px;

  z-index: 5;
  width: calc(100vw - 64px);
`

export const ToastContainer = styled('div')<ToastContainerProps>`
  /* background-color: #ff5151cc;
  background-color: #e3b630cc;
  background-color: #2cb68dcc; */
  background-color: ${({ theme, type }) => {
    if (type === 'default') {
      return `${theme.colour}cc`
    }
    if (type === 'success') {
      return '#2cb68dcc'
    }
    if (type === 'warning') {
      return '#e3b630cc'
    }
    if (type === 'error') {
      return '#ff5151cc'
    }
  }};

  width: 100%;
  min-height: 60px;
  padding: 15px;

  display: grid;
  grid-template-columns: ${({ isCross }) =>
    isCross ? '30px 1fr 30px' : '30px 1fr'};
  gap: 15px;

  border-radius: 5px;
  font-size: 14px;
  line-height: 17px;

  color: #fff;
  svg {
    align-self: center;
  }
`
